import { Stack } from "@mui/material";
import { SelectElement, useFormContext } from "react-hook-form-mui";
import { useTranslation } from "react-i18next";

import { Shared_FormTemplate_QuestionFragment } from "~/shared/components/FormTemplate/fragments/fragments.generated";
import { splitGqlUnion } from "~/shared/helpers/splitGqlUnion";

type Props = {
    namePrefix?: string;
    selectableConditionQuestions: Shared_FormTemplate_QuestionFragment[];
};

export default function QuestionConditionIsEqualFields({ namePrefix = "", selectableConditionQuestions }: Props) {
    const { t } = useTranslation("formTemplateEditor");

    const { watch } = useFormContext();

    const selectedQuestionKey = watch(`${namePrefix}conditionSelectedQuestion`);

    const selectableQuestions = selectableConditionQuestions.map(q => ({ id: q.key, label: q.name }));

    const selectedQuestion = selectableConditionQuestions.find(q => q.key === selectedQuestionKey);

    const selectedQuestionOptions =
        selectedQuestion?.type.__typename &&
        splitGqlUnion(selectedQuestion.type, {
            GqlSettingsFormTemplateQuestionTypeDropdown: t => t.options,
            GqlSettingsFormTemplateQuestionTypeSelect: t => t.options,
            GqlSettingsFormTemplateQuestionTypeAmount: () => [],
            GqlSettingsFormTemplateQuestionTypeRecording: () => [],
            GqlSettingsFormTemplateQuestionTypeText: () => [],
            GqlSettingsFormTemplateQuestionTypeDateTime: () => [],
        }).map(o => ({
            id: o.key,
            label: o.name,
        }));

    return (
        <Stack direction="row" columnGap={2} sx={{ flex: 1 }}>
            <SelectElement
                name={`${namePrefix}conditionSelectedQuestion`}
                label={t("formTemplateQuestionForm.labelField")}
                required
                variant="filled"
                fullWidth
                options={selectableQuestions}
            />
            <SelectElement
                name={`${namePrefix}conditionSelectedQuestionOption`}
                label={t("formTemplateQuestionForm.labelFieldValue")}
                required
                variant="filled"
                fullWidth
                options={selectedQuestionOptions}
            />
        </Stack>
    );
}
